module.exports = __webpack_public_path__ + "img/prize-01.9bdd8f18.png";